import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { useIntl, FormattedMessage } from '../../util/reactIntl';
import { Form } from '../../components';

import css from './Newsletter.module.css';

const Newsletter = props => {
  const { className, rootClassName } = props;
  const intl = useIntl();
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = classNames(rootClassName || css.root, className);

  const handleSubmit = async values => {
    setLoading(true);

    // Simulate API call for newsletter subscription
    try {
      console.log('Newsletter subscription:', values.email);

      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSubscribed(true);
      setLoading(false);

      // Reset form after 3 seconds
      setTimeout(() => {
        setSubscribed(false);
      }, 3000);
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      setLoading(false);
    }
  };

  const validateEmail = value => {
    if (!value) {
      return intl.formatMessage({ id: 'Newsletter.emailRequired' });
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return intl.formatMessage({ id: 'Newsletter.emailInvalid' });
    }
    return undefined;
  };

  return (
    <section className={classes}>
      <div className={css.container}>
        <div className={css.content}>
          <div className={css.textSection}>
            <h2 className={css.title}>Subscribe to our newsletter</h2>
            <p className={css.subtitle}>for our latest adverts, tips and more</p>
          </div>

          <div className={css.formSection}>
            {subscribed ? (
              <div className={css.successMessage}>
                <FormattedMessage id="Newsletter.successMessage" />
              </div>
            ) : (
              <FinalForm
                onSubmit={handleSubmit}
                render={({ handleSubmit, submitting, pristine }) => (
                  <Form className={css.form} onSubmit={handleSubmit}>
                    <div className={css.inputContainer}>
                      <Field
                        name="email"
                        validate={validateEmail}
                        render={({ input, meta }) => (
                          <div className={css.inputWrapper}>
                            <input
                              {...input}
                              type="email"
                              placeholder={intl.formatMessage({
                                id: 'Newsletter.emailPlaceholder',
                              })}
                              className={classNames(css.emailInput, {
                                [css.inputError]: meta.touched && meta.error,
                              })}
                              disabled={loading}
                            />
                            {meta.touched && meta.error && (
                              <span className={css.errorMessage}>{meta.error}</span>
                            )}
                          </div>
                        )}
                      />

                      <button
                        type="submit"
                        className={css.subscribeButton}
                        disabled={loading || submitting}
                      >
                        {loading ? (
                          <FormattedMessage id="Newsletter.subscribing" />
                        ) : (
                          <FormattedMessage id="Newsletter.subscribeButton" />
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
